import {v4} from '@mintdata/mint-kit/impl/util/uuid/v4';

export class IdUtil
{
    public static newComponentId():string
    {
        return v4();
    }

    public static newGUID():string
    {
        return v4();
    }
}
